import React from 'react';
import { Tag } from 'antd';
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    EditOutlined,
    FileDoneOutlined,
    InboxOutlined,
    LockOutlined,
    QuestionCircleOutlined,
    SafetyOutlined,
    ShoppingOutlined,
    StopOutlined,
    SyncOutlined,
    TagOutlined,
    ToolOutlined,
    UnlockOutlined
} from '@ant-design/icons';
import StatusTagMapper from './StatusTagMapper';

const StatusTag = ({ status }) => {
    const { label, color, icon } = StatusTagMapper.resolve(status);

    const resolveIcon = (iconKey) => {
        const iconMap = {
            edit: <EditOutlined />,
            'check-circle': <CheckCircleOutlined />,
            clock: <ClockCircleOutlined />,
            sync: <SyncOutlined spin />,
            stop: <StopOutlined />,
            'file-done': <FileDoneOutlined />,
            tool: <ToolOutlined />,
            inbox: <InboxOutlined />,
            'close-circle': <CloseCircleOutlined />,
            safety: <SafetyOutlined />,
            unlock: <UnlockOutlined />,
            lock: <LockOutlined />,
            shopping: <ShoppingOutlined />,
            tag: <TagOutlined />,
            question: <QuestionCircleOutlined />
        };

        return iconMap[iconKey] || iconMap.question;
    };

    return (
        <Tag color={color} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            {resolveIcon(icon)}
            {label}
        </Tag>
    );
};

export default StatusTag;
